export default __webpack_public_path__ + "e28b837.png";